import styles from './ImageSearchResultSkeleton.module.less';

export default function ImageSearchResultSkeleton() {
  return (
    <div className={styles.container}>
      {/* 顶部结果统计区域骨架 */}
      <div className={styles.resultTopSkeleton}>
        <div className={styles.skeletonResultText} />
        <div className={styles.skeletonButton} />
      </div>

      {/* 图片网格骨架 */}
      <div className={styles.gridSkeleton}>
        {Array.from({ length: 20 }).map((_, index) => (
          <div key={index} className={styles.cardSkeleton}>
            {/* 图片区域骨架 */}
            <div className={styles.imageSkeletonWrapper} />

            {/* 底部信息栏骨架 */}
            <div className={styles.bottomBarSkeleton}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonDomain} />
            </div>
          </div>
        ))}
      </div>

      {/* 底部锁定区域骨架 */}
      <div className={styles.bottomSkeleton}>
        <div className={styles.skeletonUnlockButton} />
      </div>
    </div>
  );
}
